// Load Libraries
var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var mailcheck = require('mailcheck');

// MailCheck Config
var MAILCHECK_INPUT         = 'input[type=email]';      // Selector for fields to validate
var MAILCHECK_CONTAINER     = '.form__field';           // Selector for container that holds the field+suggestion
var MAILCHECK_SUGGESTION    = '.mailcheck__email';      // Selector to populate with the suggestion
var MAILCHECK_ACCEPT        = '.mailcheck__accept';     // Selector that can be selected to accept suggestion
var MAILCHECK_SUGGESTED     = 'form__field--mailcheck'; // Class to add to container when a suggestion is available

// Domain Suggestions
var domains = [
    /* Custom brand domains */
    'iamota.com', 'pne.ca',

    /* Default domains included */
    'facebook.com', 'gmail.com', 'gmx.com', 'googlemail.com', 'google.com', 'hotmail.com', 'mac.com',
    'me.com', 'mail.com', 'msn.com', 'live.com', 'yahoo.com',

    /* Other global domains */
    'email.com', 'games.com' /* AOL */, 'gmx.net', 'hush.com', 'hushmail.com', 'icloud.com', 'inbox.com',
    'lavabit.com', 'love.com' /* AOL */, 'outlook.com', 'pobox.com', 'rocketmail.com' /* Yahoo */,
    'safe-mail.net', 'wow.com' /* AOL */, 'ygm.com' /* AOL */, 'ymail.com' /* Yahoo */, 'zoho.com', 'fastmail.fm',
    'aim.com',

    /* Canadian ISP domains */
    'shaw.ca', 'telus.net', 'sympatico.ca', 'bell.net', 'rogers.com', 'sasktel.net', 'videotron.ca', 'cogeco.ca',
    'eastlink.ca', 'dccnet.com', 'mts.net', 'mymts.net', 'escape.ca',

    /* Canadian universities */
    'ubc.ca', 'interchange.ubc.ca', 'alumni.ubc.ca', 'sfu.ca', 'alumni.sfu.ca', 'mcmaster.ca', 'mcgill.ca',
    'queensu.ca', 'ualberta.ca', 'ucalgary.ca', 'unb.ca', 'usask.ca', 'uwaterloo.ca', 'uwo.ca', 'uqam.ca',

    /* Canadian domains */
    'yahoo.ca', 'live.ca', 'msn.ca', 'yahoo.ca', 'hotmail.ca',

    /* United States ISP domains */
    'aol.com', 'att.net', 'comcast.net', 'bellsouth.net', 'charter.net', 'comcast.net', 'cox.net', 'earthlink.net',
    'juno.com', 'sbcglobal.net', 'verizon.net', 'optonline.net', 'roadrunner.com', 'juno.com',

    /* United States Universities */
    'ucla.edu',

    /* British ISP domains */
    'btinternet.com', 'virginmedia.com', 'blueyonder.co.uk', 'freeserve.co.uk', 'live.co.uk',
    'ntlworld.com', 'o2.co.uk', 'orange.net', 'sky.com', 'talktalk.co.uk', 'tiscali.co.uk',
    'virgin.net', 'wanadoo.co.uk', 'bt.com',

    /* Domains used in Europe */
    'hotmail.co.uk', 'yahoo.co.uk',

    /* Domains used in Asia */
    'sina.com', 'qq.com', 'naver.com', 'hanmail.net', 'daum.net', 'nate.com', 'yahoo.co.jp', 'yahoo.co.kr', 'yahoo.co.id', 'yahoo.co.in', 'yahoo.com.sg', 'yahoo.com.ph',

    /* French ISP domains */
    'hotmail.fr', 'live.fr', 'laposte.net', 'yahoo.fr', 'wanadoo.fr', 'orange.fr', 'gmx.fr', 'sfr.fr', 'neuf.fr', 'free.fr',

    /* German ISP domains */
    'gmx.de', 'hotmail.de', 'live.de', 'online.de', 't-online.de' /* T-Mobile */, 'web.de', 'yahoo.de',

    /* Russian ISP domains */
    'mail.ru', 'rambler.ru', 'yandex.ru', 'ya.ru', 'list.ru',

    /* Belgian ISP domains */
    'hotmail.be', 'live.be', 'skynet.be', 'voo.be', 'tvcablenet.be', 'telenet.be',

    /* Argentinian ISP domains */
    'hotmail.com.ar', 'live.com.ar', 'yahoo.com.ar', 'fibertel.com.ar', 'speedy.com.ar', 'arnet.com.ar',

    /* Domains used in Mexico */
    'hotmail.com', 'gmail.com', 'yahoo.com.mx', 'live.com.mx', 'yahoo.com', 'hotmail.es', 'live.com', 'hotmail.com.mx', 'prodigy.net.mx', 'msn.com'
];
var secondLevelDomains = ['hotmail', 'yahoo', 'live'];
var topLevelDomains = ['ca', 'com', 'net', 'org'];


module.exports = function() {
    // Validate Email Inputs against popular domain suggestions
    $(MAILCHECK_INPUT).on('blur', function() {
        // console.log('mailchecking');
        $(this).mailcheck({
            domains: domains,                       // optional
            secondLevelDomains: secondLevelDomains, // optional
            topLevelDomains: topLevelDomains,       // optional

            // Suggestion Found
            suggested: function(element, suggestion) {
                // Get the input field container
                var $field = $(element).closest(MAILCHECK_CONTAINER);

                // Populate Suggestion
                $field.find(MAILCHECK_SUGGESTION).html(suggestion.full);

                // Indicate that there is a suggestion
                $field.addClass(MAILCHECK_SUGGESTED);
            },

            // No Suggestion
            empty: function(element) {
                // Get the input field container
                var $field = $(element).closest(MAILCHECK_CONTAINER);

                // Remove suggestion indicator
                $field.removeClass(MAILCHECK_SUGGESTED);
            }
        });
    });

    // Allow the user to update their email based on a suggestion
    $(MAILCHECK_ACCEPT).on('click', function() {
        // Get the input field container
        var $field = $(this).closest(MAILCHECK_CONTAINER);

        // Get the Suggestion
        var suggestion = $field.find(MAILCHECK_SUGGESTION).text();

        // Remove suggestion indicator
        $field.removeClass(MAILCHECK_SUGGESTED);

        // Use the suggestion
        $field.find(MAILCHECK_INPUT).val(suggestion);
    });
};
